import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import type { PaymentAdjustmentConfirmDialogsProps } from '../../types/modals';

export function PaymentAdjustmentConfirmDialogs({
  tid,
  showApplicationFeeRefundConfirm,
  applicationFeeRefundStatusMessage,
  onApplicationFeeRefundContinue,
  onApplicationFeeRefundDismiss,
  showConfirm,
  shouldUseRefundConfirmation,
  shouldUseChargebackConfirmation,
  submitConfirmMessage,
  onFinalSubmit,
  onGenerateChargebackPacket,
  onConfirmDismiss,
}: PaymentAdjustmentConfirmDialogsProps) {
  return (
    <>
      <ConfirmDialog
        isOpen={showApplicationFeeRefundConfirm}
        title="Application Fee Refund"
        message={`You are about to refund the Application Fee. ${applicationFeeRefundStatusMessage}Do you want to continue?`}
        primaryLabel="Continue"
        secondaryLabel="Cancel"
        onPrimary={onApplicationFeeRefundContinue}
        onSecondary={onApplicationFeeRefundDismiss}
        onDismiss={onApplicationFeeRefundDismiss}
        primaryFirst
        hideClose
        overlayDataTestId={`${tid}-application-fee-refund-confirm`}
        primaryButtonDataTestId={`${tid}-application-fee-refund-continue-btn`}
        secondaryButtonDataTestId={`${tid}-application-fee-refund-cancel-btn`}
      />

      <ConfirmDialog
        isOpen={showConfirm}
        title="Confirm"
        message={submitConfirmMessage}
        primaryLabel={
          shouldUseChargebackConfirmation
            ? 'Chargeback'
            : shouldUseRefundConfirmation
              ? 'Yes'
              : 'Confirm'
        }
        secondaryLabel={
          shouldUseChargebackConfirmation
            ? 'Credit Report'
            : shouldUseRefundConfirmation
              ? 'No'
              : 'Cancel'
        }
        onPrimary={onFinalSubmit}
        onSecondary={
          shouldUseChargebackConfirmation
            ? onGenerateChargebackPacket
            : onConfirmDismiss
        }
        primaryFirst
        presentation={
          shouldUseChargebackConfirmation || shouldUseRefundConfirmation
            ? 'compactAngular'
            : 'default'
        }
        hideClose={
          shouldUseChargebackConfirmation || shouldUseRefundConfirmation
        }
        overlayDataTestId="application-modal-payment-adjustment-confirm"
        primaryButtonDataTestId="application-modal-payment-adjustment-confirm-btn"
        secondaryButtonDataTestId={
          shouldUseChargebackConfirmation
            ? 'application-modal-payment-adjustment-credit-report-btn'
            : 'application-modal-payment-adjustment-cancel-btn'
        }
        closeButtonDataTestId="application-modal-payment-adjustment-confirm-close-button"
      />
    </>
  );
}
